import { ExternalIcon } from "shared/components/Icons";
import { SMALL, PAGE_TYPE } from "shared/utils/constants";
import { useRouter } from "next/router";
import cx from "classnames";
import Link from "next/link";
import styles from "./SiteLink.module.css";
import { useAppContext } from "shared/utils/useAppContext";

export const SiteLink = ({
  children,
  className,
  href,
  noExternalIcon,
  size,
  type,
  isOutOfScope,
  shallow = false,
  ...rest
}) => {
  const { locale } = useRouter();
  const { scope, createInternalHref } = useAppContext();

  if (type === PAGE_TYPE) type = `${scope}.${PAGE_TYPE}`;

  if (type) {
    return (
      <Link
        locale={false}
        href={
          typeof href === "object"
            ? href
            : createInternalHref({ href, locale, type, isOutOfScope })
        }
        shallow={shallow}
      >
        <a
          className={cx(styles.link, className)}
          target={isOutOfScope ? "_blank" : "_self"}
          {...rest}
        >
          {children}
          {isOutOfScope && <ExternalIcon />}
        </a>
      </Link>
    );
  }

  const isExternal = href && href.indexOf("http") === 0;

  return (
    <a
      className={cx(styles.link, { [styles.small]: size === SMALL }, className)}
      href={href}
      rel={isExternal ? "noopener noreferrer" : null}
      target={isExternal ? "_blank" : "_self"}
      {...rest}
    >
      {children}
      {isExternal && !noExternalIcon && <ExternalIcon />}
    </a>
  );
};
